import { AvatarWithLabel, AvatarLetter } from '@pocketlaw/tetris';
import useAccount from 'shared/domains/users/hooks/useAccount';
export function AccountSummaryItem() {
    var _a;
    const account = useAccount();
    const { name = '', email } = ((_a = account.data) === null || _a === void 0 ? void 0 : _a.profile) || {};
    const text = name.substring(0, 1).toUpperCase();
    return (<AvatarWithLabel title={name} subtitle={email}>
      <AvatarLetter>{text}</AvatarLetter>
    </AvatarWithLabel>);
}
